<template>
  <div class="sale-info">
    <div class="sale-info-c">
      <div class="sale-info-c-t">
        <h3>{{ type === 'add' ? '新增销售' : '编辑销售信息' }}</h3>
        <mk-iconfont
          class="close"
          icon-class="guanbi"
          @click.native="cancel"
        ></mk-iconfont>
      </div>
      <mk-form
        class="form"
        label-width="60px"
      >
        <mk-form-item label="姓名:">
          <mk-input
            v-model="name"
            maxlength="10"
            placeholder="请输入姓名"
            show-word-limit
          />
        </mk-form-item>
        <mk-form-item label="电话:">
          <mk-input
            v-model="telephone"
            maxlength="11"
            placeholder="请输入手机号，不可重复"
            show-word-limit
          />
        </mk-form-item>
      </mk-form>
      <div class="btn-group">
        <mk-button-biz
          width="64px"
          @click="cancel"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="64px"
          @click="cofirm"
        >
          确认
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'add' // 新增/编辑
    },
    initData: {
      type: Object,
      default () {
        return {}
      }
    },
    editId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      name: '',
      telephone: ''
    }
  },
  created () {
    if (this.type === 'edit') {
      this.name = this.initData.name
      this.telephone = this.initData.telephone
    }
  },
  methods: {
    verificate () {
      let message = ''
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/g
      let regCode = /^[0-9a-zA-Z]+$/g
      if (!this.name) return '请输入姓名'
      if (!this.telephone) return '请输入手机号码'
      if (this.telephone && !reg.test(this.telephone)) {
        return '请输入正确的手机号码'
      }
    },
    showError (errorMsg) {
      this.$message({
        type: 'error',
        message: errorMsg,
        showClose: true
      })
    },
    showSuccess (msg) {
      this.$message({
        type: 'success',
        message: msg,
        showClose: true
      })
    },
    cofirm () {
      if (this.verificate()) {
        this.showError(this.verificate())
      } else {
        if (this.type === 'add') {
          this.addSale()
        } else {
          this.editSale()
        }
      }
    },
    async addSale () {
      const res = await BIZAPIS.SalesApi.yqfSalesManageCreatePost({
        name: this.name,
        telephone: Number(this.telephone)
      })
      if (res.success) {
        this.showSuccess('新增销售成功')
        this.$emit('success')
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          showClose: true
        })
      }
    },
    async editSale () {
      const res = await BIZAPIS.SalesApi.yqfSalesManageUpdatePost({
        _id: this.editId,
        name: this.name,
        telephone: Number(this.telephone)
      })
      if (res.success) {
        this.showSuccess('更新销售信息成功')
        this.$emit('success')
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          showClose: true
        })
      }
    },
    cancel () {
      this.name = ''
      this.telephone = ''
      this.verifyCode = ''
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.sale-info {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2001;

  .sale-info-c {
    width: 368px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;

    .sale-info-c-t {
      // width: calc(100% - 40px);
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;
      border-radius: 4px 4px 0 0;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 14px;
      }

      .close {
        cursor: pointer;
        font-size: 14px;
        color: #bfbfbf;
      }
    }
  }

  .form {
    width: calc(100% - 40px);
    margin: 0 auto;
    padding: 20px 0;

    /deep/ .el-form-item {
      margin-bottom: 10px;

      .el-form-item__label {
        line-height: 32px;
        font-size: 13px;
      }

      .el-form-item__content {
        line-height: 32px;
      }
    }
  }

  .btn-group {
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
    margin-bottom: 20px;
  }
}
</style>
